"use client";

export default function CartSyncProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return children;
}
